import { InjectionToken } from '@angular/core';

export type WindowAnimState = 'opening' | 'closing' | 'minimizing' | 'restoring' | null;

export interface WindowAnimationConfig {
  openClass: string;
  closeClass: string;
  minimizeClass: string;
  restoreClass: string;
  openDurationMs: number;
  closeDurationMs: number;
  minimizeDurationMs: number;
  restoreDurationMs: number;
}

export const WINDOW_ANIMATION = new InjectionToken<WindowAnimationConfig>('WINDOW_ANIMATION');

export const DEFAULT_WINDOW_ANIMATION: WindowAnimationConfig = {
  openClass: 'window-opening-default',
  closeClass: 'window-closing-default',
  minimizeClass: 'window-minimizing-default',
  restoreClass: 'window-restoring-default',
  openDurationMs: 333,
  closeDurationMs: 333,
  minimizeDurationMs: 333,
  restoreDurationMs: 333,
};

export const EPIC_NFT_ANIMATION: WindowAnimationConfig = {
  openClass: 'window-opening',
  closeClass: 'window-closing',
  minimizeClass: 'window-minimizing',
  restoreClass: 'window-restoring',
  openDurationMs: 10000,
  closeDurationMs: 300,
  minimizeDurationMs: 300,
  restoreDurationMs: 300,
};
